<template>
    <div>
        <template v-if="item[itemShowKey]">
            <el-form ref="assistantForm" class="el-form--floating" style="width: 200px">
                <el-form-item label="" class="el-form-item--normal-margin">
                    <!-- submitData.helpers.length > 0 是因為要晚點渲染 -->
                    <template v-if="submitData[submitDataKey].length > 0 ">
                        <el-select v-model="submitData[submitDataKey][0].id">
                            <el-option label="不指派" value=""></el-option>
                            <el-option v-for="(assignItem, assignIndex) in assignList" :key="assignIndex"
                                :value="assignItem.id"
                                :label="`${assignItem.name} ${assignItem.sameStore ? '(同分店)' : '(不同分店)'}`">
                                {{ assignItem.name }} ({{ assignItem.sameStore ? '同分店' : '不同分店' }})
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
            </el-form>
        </template>
        </div>
</template>

<script>
export default {
    name: 'HelperSelectOption',
    components: {},
    mixins: [],
    props: {
        itemShowKey: {
            type: String,
            require: true,
            default: ''
        },
        item: {
            type: Object,
            default: () =>{},
            require: true
        },
        submitData: {
            type: Object,
            default: () =>{},
            require: true
        },
        submitDataKey: {
            type: String,
            default: '',
            require: true
        },
        assignList: {
            type: Array,
            default: () => [],
            require: true
        }
    },
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {},
};
</script>

<style lang="scss" module></style>
